import type { MissionStatusCode, OperationStatusCode } from '@killer-party/contracts';

const MISSION_STATUS_LABELS: Record<MissionStatusCode, string> = {
  READY: 'Prêt',
  STARTED: 'En lice',
  SUCCEEDED: 'Vainqueur',
  FAILED: 'Éliminé',
  ABORTED: 'Abandon',
};

const OPERATION_STATUS_LABELS: Record<OperationStatusCode, string> = {
  DRAFT: 'Brouillon',
  VALIDATED: 'Validée',
  STARTED: 'Démarrée',
  COMPLETE: 'Terminée',
};

export function missionStatusLabel(statusCode: MissionStatusCode): string {
  return MISSION_STATUS_LABELS[statusCode];
}

export function operationStatusLabel(statusCode: OperationStatusCode): string {
  return OPERATION_STATUS_LABELS[statusCode];
}
